import $ from 'jquery';
import Production from "biogas/production.js";
import Consume from "biogas/consume.js";
import moment from "moment";
import Form from 'biogas/form.js';
import Datatable from 'biogas/datatable.js';
import {GASTYPES} from '../../../constants.js';
import {IMPORT_LGG_GASTYPES} from '../../../constants.js';
import {USAGE_GROUPS} from '../../../constants.js';
import {PRODUCTION_GROUPS} from '../../../constants.js';

var clr;
var periodData;
var importData;
var doNotPropogate = false;

const GROUPS = USAGE_GROUPS.concat(PRODUCTION_GROUPS);
const INVALID_GAS_TYPE = {key: '---', value: '---', import:false};
const CORRECTION_DAYS_ALLOWED = 270;

export class Clearing {
    constructor() {

        this.meta = null;
        this.periodid = null;
        this.cid = null;
        this.companies = [];
        this.gastypeCache = null;
        this.gastypesById = {};
        this.periods = {};
        this.prodperiods = {};

        this.etbl = null;
        this.vtbl = null;
        this.importTable = null;
        this.importLGGTable = null;

        this.eventTimestamp = null;

	clr = this;
    }

    printamount(key, data) {
        return numberWithCommas(data[key]) + ' kg';
    }

    printfactor(key, data) {
        return round(data[key], 8).toString();
    }

    createcertificatelinks(key,data){
        var id = data['id'];
        return `<div id="certificate-${id}" class="certificate-div" data-id="${id}">${clr.populateCertificateDiv(id)}</div>`;

    }

    getCertificateData(id) {
        if (typeof(periodData) == 'undefined') {
            return {};
        }

        if (typeof(importData) == 'undefined') {
            return {};
        }

        var data = importData[Object.keys(importData).find(key => importData[key]['id'] == id)];
        if (typeof data == 'undefined')
            return {};

        var periodList = document.getElementsByName('period');
        var pData = periodData[periodList[0].selectedIndex];
        var periodEnd = pData['changeuntil'];
        periodEnd = new Date(Date.parse(periodEnd));

        var transmitted = !!pData['transmitted'];
        var transmittedDate = new Date(pData['transmitted']);

        var oneYearAfterClose = new Date(periodEnd);
        oneYearAfterClose.setFullYear(oneYearAfterClose.getFullYear() +1);
        var today = new Date(Date.now());
        today.setDate(today.getDate() - 1);
        var periodOpen = today < periodEnd;
        var hasCertificate = !!data['certificate'];
        var certificateDate = data['certificate_created_date'];
        var hadCertificate = certificateDate != null;
        var changeCutoff = new Date(today);
        if (hasCertificate || hadCertificate) {
            certificateDate = new Date(certificateDate);
            changeCutoff = new Date(certificateDate);
            changeCutoff.setDate(changeCutoff.getDate() + CORRECTION_DAYS_ALLOWED);
        }

        var canDelete = hasCertificate && (periodOpen || (transmitted && (certificateDate > transmittedDate) && (today < changeCutoff)));
        var canAdd = !hasCertificate && (periodOpen || (transmitted && (today < oneYearAfterClose)));
        return {certificate: hasCertificate, can_delete_certificate: canDelete, can_add_certificate: canAdd };
    }

    populateCertificateDiv(id) {

        var content = "";
        var data = this.getCertificateData(id);
        if (!!data['certificate']) {
          var link = '/api/v1/companies/' + clr.cid + '/certificates/' + id + ".pdf";
          content = "<a href='" + link + "' target='_blank'><img class='show-certificate' src='/images/pdf.gif'></a>";
          if (data['can_delete_certificate']) {
             content = content + "<img class='delete-certificate' src='/images/delete.png'>";// + $("#saveform").html();
          } else {
             content = content + "<img class='invisible' src='/images/pdf.gif'>";// + $("#saveform").html();
          }
        } else if (data['can_add_certificate']){

          var button_title = $('#biogas-div').attr('data-certificate-requirements');
          var button_text = $('#biogas-div').attr('data-upload-button-text');

          content = "<input accept='application/pdf' class='upload-certificate' type='file' id='upload-certificate-" + id + "' />" +
                 "<a title='" + button_title + "'  class='btn add-certificate'>" + button_text + "</a>";
        }

        return content;
    }

    amountString(amount) {
        return numberWithCommas(amount) + ' kg';
    }

    printcomment(key, data) {
        if (data[key]) {
            return data[key].substr(0, 100);
        } else {
            return '';
        }
    }

    csel(key, data) {
        return data.companyname;
    }

    printtype(key, data) {
        // todo: check if changable
        return data['gasname'];
    }

    updateMonth1(model, mid, m, value, cb) {
        this.updateAmount(model, mid, m, {oldAmount: 0, newAmount: 0}, cb, {month1: value});
    }
    updateMonth2(model, mid, m, value, cb) {
        this.updateAmount(model, mid, m, {oldAmount: 0, newAmount: 0}, cb, {month2: value});
    }
    updateMonth3(model, mid, m, value, cb) {
        this.updateAmount(model, mid, m, {oldAmount: 0, newAmount: 0}, cb, {month3: value});
    }

    updateAmount(model, mid, m, values, cb, params) {
        var self = this;
        if (params === undefined) {
            if (['modelE', 'modelV'].includes(model['rowLabel'])) {
                params = { amount: values['newAmount'], oldAmount: values['oldAmount']  };
            } else {
                params = { amount: values  };
            }
        }

        params['model'] = model.rowLabel;

        $.ajax({
            type: "PUT",
            url: model.patchurl + mid,
            data: params,
            dataType: 'json'
        }).done(function (data) {
            cb(null, data);
            if (model.rowLabel == "importLGG") {
                updateLGGField(model, mid, data, 'sum')
                updateLGGField(model, mid, data, 'amount')
            }
            model.recompute();
        }).fail(function (payload) {
            var me = $('tr[data-id="' + mid + '"][data-label="' + model.rowLabel + '"] td.' + m.key);
            if (payload.responseJSON) {
                self.log(payload.responseJSON.message, me);
                cb(payload);
            } else {
                self.log(payload.responseText, me);
                cb(payload);
            }
        });
    }

    updateCompany(model, mid, m, value, cb) {
        var self = this;
        $.ajax({
            type: "PUT",
            url: model.patchurl + mid,
            data: { companyid: value },
            dataType: 'json'
        }).done(function (data) {
            cb(null, data);
            switch(model.rowLabel) {
              case "modelE":
                self.etbl.loadData();
                break;
              case "modelV":
                self.vtbl.loadData();
                break;
            }
        }).fail(function (payload) {
            var me = $('tr[data-id="' + mid + '"][data-label="' + model.rowLabel + '"]');
            if (payload.responseJSON) {
                self.log(payload.responseJSON.message, me);
                cb(payload);
            } else {
                self.log(payload.responseText, me);
                cb(payload);
            }
        });
    }

    updateType(model, mid, value, cb) {
        $.ajax({
            type: "PUT",
            url: model.patchurl + mid,
            data: { gastype: value },
            dataType: 'json'
        }).done(function (data) {
            cb(null, data);
            model.recompute();
        });
    }

    showOrHideLGGSummary() {
        let LGG_total = 0;
        for (let i = 0; i < IMPORT_LGG_GASTYPES.length; i++) {
            for(let j = 0; j < GROUPS.length; j++) {
                let element = $('#LGG-summary-table .' + GROUPS[j] + '-' + IMPORT_LGG_GASTYPES[i]);
                if(element && element.length) {
                    LGG_total += parseInt(element.attr('data-amount'));
                }
            }
        }
        if (LGG_total === 0) {
            $('#LGG-summary-table').hide();
        } else {
            $('#LGG-summary-table').show();
        }
    }

    setupHandel(clearing) {
        this.periodid = this.meta.attr('data-period');
        var baseurl = '/api/v1';
        var self = this;

        var updateAmount = this.updateAmount.bind(this);
        var updateMonth1 = this.updateMonth1.bind(this);
        var updateMonth2 = this.updateMonth2.bind(this);
        var updateMonth3 = this.updateMonth3.bind(this);
        var updateCompany = this.updateCompany.bind(this);
        var getTypes = this.getTypes.bind(this);
        var getFile = this.getFile.bind(this);
        var updateFile = this.updateFile.bind(this);
        var getImportTypes = this.getImportTypes.bind(this);
        var getImportLGGTypes = this.getImportLGGTypes.bind(this);

        var modelE = {
            rowLabel: "modelE",
            patchurl: '/api/v1/companies/' + this.cid + '/einkaeufe/',
            sellerid: { key: 'sellerId', type: 'select', data: function(d, cd) {clearing.getCompaniesWithEmpty(d,cd);}, elemkey: 'companyid', elemvalue: 'name', update: updateCompany, template: this.csel, valCol: 'sellerId', edit: 1 },
            amount: { key: 'amount', type: 'number', min: 0, update: updateAmount, template: this.printamount, valCol: 'amount', edit: 1 },
            gastype: { key: 'gastype', type: 'select', data: getTypes, elemkey: 'key', elemvalue: 'value', update: this.updateElement, template: this.printtype, valCol: 'gastype', edit: 1 },
            comment: { key: 'comment', type: 'textarea', update: this.updateElement, valCol: 'comment', edit: 1 },
            actions: { key: 'actions', template: '<img class="delete" src="/images/delete.png">' + $("#saveform").html() },
            empty: { key: 'empty', template: ' ' },
            addEntry: function (me, data, cb) {
                $.ajax({
                    type: "POST",
                    url: '/api/v1/companies/' + clr.cid + '/periods/' + self.periodid + '/einkaeufe',
                    data: data,
                    dataType: 'json'
                }).done(function (data) {
                    cb(null, data);
                }).fail(function (payload) {
                    if (payload.responseJSON) {
                        self.log(payload.responseJSON.message, me);
                    } else {
                        self.log(payload.responseText, me);
                    }
                });
            },
            deleteEntry: function (me, id, cb) {
                $.ajax({
                    type: "DELETE",
                    url: '/api/v1/companies/' + clr.cid + '/einkaeufe/' + id,
                    dataType: 'json'
                }).done(function (data) {
                    cb(null, data);
                }).fail(function (payload) {
                    if (payload.responseJSON) {
                        self.log(payload.responseJSON.message, me);
                    } else {
                        self.log(payload.responseText, me);
                    }
                });
            },
            recompute: function () {
                var amount = self.recomputeTotal($("#einkaeufe"));
                for (let i = 0; i < GASTYPES.length; i++) {
                    let element = $('#totalamount .einkauf-' + GASTYPES[i]);
                    if(element && element.length) {
                      element.attr('data-amount', amount[GASTYPES[i]]);
                      element.text(numberWithCommas(amount[GASTYPES[i]]));
                    }
                }
                self.recomputeSummary();
            }
        };

        var modelV = {
            rowLabel: "modelV",
            patchurl: '/api/v1/companies/' + this.cid + '/verkaeufe/',
            sellerid: { key: 'sellerId', type: 'select', data: function(d, cd) { clearing.getCompaniesWithEmpty(d, cd);}, elemkey: 'companyid', elemvalue: 'name', update: updateCompany, template: this.csel, valCol: 'sellerId', edit: 1 },
            amount: { key: 'amount', type: 'number', min: 0, update: updateAmount, template: this.printamount, valCol: 'amount', edit: 1 },
            gastype: { key: 'gastype', type: 'select', data: getTypes, elemkey: 'key', elemvalue: 'value', update: this.updateElement, template: this.printtype, valCol: 'gastype', edit: 1 },
            comment: { key: 'comment', type: 'textarea', update: this.updateElement, valCol: 'comment', edit: 1 },
            actions: { key: 'actions', template: '<img class="delete" src="/images/delete.png">' + $("#saveform").html() },
            empty: { key: 'empty', template: ' ' },
            addEntry: function (me, data, cb) {
                $.ajax({
                    type: "POST",
                    url: '/api/v1/companies/' + clr.cid + '/periods/' + self.periodid + '/verkaeufe',
                    data: data,
                    dataType: 'json'
                }).done(function (data) {
                    cb(null, data);
                }).fail(function (payload) {
                    if (payload.responseJSON) {
                        self.log(payload.responseJSON.message, me);
                    } else {
                        self.log(payload.responseText, me);
                    }
                });
            },
            deleteEntry: function (me, id, cb) {
                $.ajax({
                    type: "DELETE",
                    url: '/api/v1/companies/' + clr.cid + '/verkaeufe/' + id,
                    dataType: 'json'
                }).done(function (data) {
                    cb(null, data);
                }).fail(function (payload) {
                    if (payload.responseJSON) {
                        self.log(payload.responseJSON.message, me);
                    } else {
                        self.log(payload.responseText, me);
                    }
                });
            },
            recompute: function () {
                var amount = self.recomputeTotal($('#verkaeufe'));
                for (let i = 0; i < GASTYPES.length; i++) {
                    let element = $('#totalamount .verkauf-' + GASTYPES[i]);
                    if(element && element.length) {
                      element.attr('data-amount', amount[GASTYPES[i]]);
                      element.text(numberWithCommas(amount[GASTYPES[i]]));
                    }
                }
                self.recomputeSummary();
            }
        };

        var cols = [
            'sellerid',
            'amount',
            'gastype',
            'comment',
            'actions'
        ];

        this.etbl = new Datatable();
        this.etbl.init("#einkaeufe", {
            url: baseurl + '/companies/' + clr.cid + '/periods/' + self.periodid + '/einkaeufe',
            bodysel: '.datacontent',
            idcol: 'id',
            columns: cols,
            model: modelE,
            okbutton: $("#okbutton").html(),
            datahandler: function (data) {
                // called after data loaded                
                self.recomputeTotal($('#einkaeufe'));
            }
        });

        this.vtbl = new Datatable();
        this.vtbl.init("#verkaeufe", {
            url: baseurl + '/companies/' + clr.cid + '/periods/' + self.periodid + '/verkaeufe',
            bodysel: '.datacontent',
            idcol: 'id',
            columns: cols,
            model: modelV,
            okbutton: $("#okbutton").html(),
            datahandler: function (data) {
                // called after data loaded                
                self.recomputeTotal($('#verkaeufe'));
            }
        });

        function recomputeImport() {
          var amount1 = self.recomputeTotal($("#importe"));
          var amount2 = self.recomputeTotal($("#importeLGG"));
          for (let i = 0; i < GASTYPES.length; i++) {
            let gastype = GASTYPES[i];
            let element = $('#totalamount .import-' + gastype);
            if(element && element.length) {
              let amount = amount1[gastype] + amount2[gastype];
              element.attr('data-amount', amount);
              element.text(numberWithCommas(amount));
            }
          }
          self.recomputeSummary();
        }

        if(document.getElementById('importe')) {
          var modelImport = {
              rowLabel: "importe",
              patchurl: '/api/v1/companies/' + this.cid + '/importe/',
              zoll: { key: 'zoll', type: 'text', update: this.updateElement, valCol: 'zoll', edit: 1 },
              amount: { key: 'amount', type: 'number', min: 0, update: updateAmount, template: this.printamount, valCol: 'amount', edit: 1 },
              gastype: { key: 'gastype', type: 'select', data: getImportTypes, elemkey: 'key', elemvalue: 'value', update: this.updateElement, template: this.printtype, valCol: 'gastype', edit: 1 },
              certificate: { key: 'certificate', type: 'file', data: getFile, template: this.createcertificatelinks,  update: updateFile, valCol: 'certificate', edit: 1},
              comment: { key: 'comment', type: 'textarea', update: this.updateElement, valCol: 'comment', edit: 1 },
              actions: { key: 'actions', template: '<img class="delete" src="/images/delete.png">' + $("#saveform").html() },
              empty: { key: 'empty', template: ' ' },
              repopulateCertificate: function(div, id, hasCertificate) {
                  div[0].innerHTML = clr.populateCertificateDiv(id);
              },

              stopPropogation() {
                  doNotPropogate = true;
              },

              getEventTimestamp() {
                  return clr.eventTimestamp;
              },
 
              setEventTimestamp(newTimestamp) {
                  clr.eventTimestamp = newTimestamp;
              },

              addCertificate: function (me, id, cb) {
                  var formData = new FormData();
                  var inputFile = $(`#upload-certificate-${id}`);
                  var maxFileSize = parseInt($('#biogas-div').attr('data-certificate-max-bytes'));
                  var fileType = inputFile[0].files[0].name.split(".").pop().toUpperCase();
                  if ((fileType != "PDF") || (inputFile[0].files[0].size > maxFileSize)) {
                      var message = $('#biogas-div').attr('data-file-invalid');
                      self.log(message, me);
                      cb(message);
                  } else {

                  
                      formData.append("file", inputFile[0].files[0]);
                      $.ajax({
                          type: "POST",
                          url: encodeURI('/api/v1/companies/' + clr.cid + '/certificates/' + id + "?originalFilename=" + inputFile[0].files[0].name),
                          data: formData,
                          dataType: 'json',
                          contentType: false,
                          processData: false,
                      }).done(function (data) {
                          var index = Object.keys(importData).find(key => importData[key]['id'] == id);
                          importData[index]['certificate'] = true;
                          cb(null, data);
                      }).fail(function (payload) {
                          if (payload.responseJSON) {
                              self.log(payload.responseJSON.message, me);
                          } else {
                              self.log(payload.responseText, me);
                          }
                      });
                  }
              },
              deleteCertificate: function (me, id, cb) {
                  $.ajax({
                      type: "DELETE",
                      url: '/api/v1/companies/' + clr.cid + '/certificates/' + id,
                      dataType: 'json'
                  }).done(function (data) {
                      var index = Object.keys(importData).find(key => importData[key]['id'] == id);
                      importData[index]['certificate'] = false;
                      cb(null, data);
                  }).fail(function (payload) {
                      if (payload.responseJSON) {
                          self.log(payload.responseJSON.message, me);
                      } else {
                          self.log(payload.responseText, me);
                      }
                  });
              },
              addEntry: function (me, data, cb) {
                  $.ajax({
                      type: "POST",
                      url: '/api/v1/companies/' + clr.cid + '/periods/' + self.periodid + '/importe',
                      data: data,
                      dataType: 'json'
                  }).done(function (data) {
                      data['certificate'] = false;
                      importData.push(data);
                      cb(null, data);
                  }).fail(function (payload) {
                      if (payload.responseJSON) {
                          self.log(payload.responseJSON.message, me);
                      } else {
                          self.log(payload.responseText, me);
                      }
                  });
              },
              deleteEntry: function (me, id, cb) {
                  $.ajax({
                      type: "DELETE",
                      url: '/api/v1/companies/' + clr.cid + '/importe/' + id,
                      dataType: 'json'
                  }).done(function (data) {
                      cb(null, data);
                  }).fail(function (payload) {
                      if (payload.responseJSON) {
                          self.log(payload.responseJSON.message, me);
                      } else {
                          self.log(payload.responseText, me);
                      }
                  });
              },
              recompute: recomputeImport,
          };

          this.importTable = new Datatable();
          this.importTable.init("#importe", {
              url: baseurl + '/companies/' + clr.cid + '/periods/' + self.periodid + '/importe',
              bodysel: '.datacontent',
              idcol: 'id',
              columns: ['zoll', 'amount', 'gastype', 'certificate', 'comment', 'actions'],
              model: modelImport,
              okbutton: $("#okbutton").html(),
              datahandler: function (data) {
                  importData = data;
                  // called after data loaded
                  self.recomputeTotal($('#importe'));
                  self.repopulateImportTable();
              }
          });
        }

        if(document.getElementById('importeLGG')) {
          var modelImportLGG = {
              rowLabel: "importLGG",
              patchurl: '/api/v1/companies/' + this.cid + '/importe-lgg/',
              zoll: { key: 'zoll', type: 'text', maxLength: 40, update: this.updateElement, valCol: 'zoll', edit: 1 },
              gastype: { key: 'gastype', type: 'select', data: getImportLGGTypes, elemkey: 'key', elemvalue: 'value', update: this.updateElement, template: this.printtype, valCol: 'gastype', edit: 1 },
              month1: { key: 'month1', type: 'number', min: 0, update: updateMonth1, template: this.printamount, valCol: 'month1', edit: 1 },
              month2: { key: 'month2', type: 'number', min: 0, update: updateMonth2, template: this.printamount, valCol: 'month2', edit: 1 },
              month3: { key: 'month3', type: 'number', min: 0, update: updateMonth3, template: this.printamount, valCol: 'month3', edit: 1 },
              sum: { key: 'sum', type: 'number', min: 0, template: this.printamount, valCol: 'sum'},
              amount: { key: 'amount', type: 'number', min: 0, template: this.printamount, valCol: 'amount'},
              factor: { key: 'factor', type: 'number', min: 0, template: this.printfactor, valCol: 'factor'},
              comment: { key: 'comment', type: 'textarea', update: this.updateElement, valCol: 'comment', edit: 1 },
              actions: { key: 'actions', template: '<img class="delete" src="/images/delete.png">' + $("#saveform").html() },
              empty: { key: 'empty', template: ' ' },
              addEntry: function (me, data, cb) {
                  $.ajax({
                      type: "POST",
                      url: '/api/v1/companies/' + clr.cid + '/periods/' + self.periodid + '/importe-lgg',
                      data: data,
                      dataType: 'json'
                  }).done(function (data) {
                      cb(null, data);
                  }).fail(function (payload) {
                      if (payload.responseJSON) {
                          self.log(payload.responseJSON.message, me);
                      } else {
                          self.log(payload.responseText, me);
                      }
                  });
              },
              deleteEntry: function (me, id, cb) {
                  $.ajax({
                      type: "DELETE",
                      url: '/api/v1/companies/' + clr.cid + '/importe-lgg/' + id,
                      dataType: 'json'
                  }).done(function (data) {
                      cb(null, data);
                  }).fail(function (payload) {
                      if (payload.responseJSON) {
                          self.log(payload.responseJSON.message, me);
                      } else {
                          self.log(payload.responseText, me);
                      }
                  });
              },
              recompute: recomputeImport,
          };

          this.importLGGTable = new Datatable();
          this.importLGGTable.init("#importeLGG", {
              url: baseurl + '/companies/' + clr.cid + '/periods/' + self.periodid + '/importe-lgg',
              bodysel: '.datacontent',
              idcol: 'id',
              columns: ['zoll', 'gastype', 'month1', 'month2', 'month3', 'sum', 'factor', 'amount','comment', 'actions'],
              // columns: ['zoll', 'amount', 'comment', 'actions'],
              model: modelImportLGG,
              okbutton: $("#okbutton").html(),
              datahandler: function (data) {
                  // called after data loaded
                  self.recomputeTotal($('#importeLGG'));
              }
          });
        }

        this.getSummaryTable(this.periodid);
        this.getPeriods('handel', function (err, me, data) {
            // change of period requested
            var pid;
            if (typeof me == 'number') {
                pid = me;
            } else {
                pid = me.val();
            }
            self.periodid = pid;
            var cid = self.meta.attr('data-company');
            var today = new Date();
            today.setDate(today.getDate() - 1);
            var changeuntil = new Date(self.periods[self.periodid].changeuntil);
            if (changeuntil > today) {            
                $('#einkaeufe').addClass('editable');
                self.etbl.setEditable(true);
                $('#verkaeufe').addClass('editable');
                self.vtbl.setEditable(true);
                if(self.importTable) {
                  $('#importe').addClass('editable');
                  self.importTable.setEditable(true);
                }
                if(self.importLGGTable) {
                  $('#importeLGG').addClass('editable');
                  self.importLGGTable.setEditable(true);
                }
            } else {
                $('#einkaeufe').removeClass('editable');
                self.etbl.setEditable(false);
                $('#verkaeufe').removeClass('editable');
                self.vtbl.setEditable(false);
                if(self.importTable) {
                  $('#importe').removeClass('editable');
                  self.importTable.setEditable(false);
                }
                if(self.importLGGTable) {
                  $('#importeLGG').removeClass('editable');
                  self.importLGGTable.setEditable(false);
                }
            }

            var certificateCanChange = changeuntil;
            certificateCanChange.setFullYear(changeuntil.getFullYear() + 1);
            if (certificateCanChange > today) {            
                if(self.importTable) {
                  $('#importe').addClass('certificateEditable');
                  self.importTable.setCertificateEditable(true);
                }
            }

            // get table data
            self.etbl.setURL('/api/v1/companies/' + cid + '/periods/' + self.periodid + '/einkaeufe');
            self.vtbl.setURL('/api/v1/companies/' + cid + '/periods/' + self.periodid + '/verkaeufe');
            if (self.importTable) {
              self.importTable.setURL('/api/v1/companies/' + cid + '/periods/' + self.periodid + '/importe');
            }
            if (self.importLGGTable) {
              self.importLGGTable.setURL('/api/v1/companies/' + cid + '/periods/' + self.periodid + '/importe-lgg');
              var periods = window.top.document.getElementsByName("period");
              if (periods.length == 1) {
                  var period = periods.item(0);
                  if (period.nodeName === "SELECT") {
                      var index = period.selectedIndex;
                      var firstMonth = parseInt(period[index].firstChild.data.split(".")[0])-3;
                      var table = window.top.document.getElementById("importeLGG");
                      var months = table.dataset["months"].split(",");
                      var template = table.dataset["template"];
                      var header1 = window.top.document.getElementById("lgg-month-1");
                      var header2 = window.top.document.getElementById("lgg-month-2");
                      var header3 = window.top.document.getElementById("lgg-month-3");
                      // Months are always properly aligned with the year
                      header1.innerText = template.format(months[firstMonth]);
                      header2.innerText = template.format(months[firstMonth+1]);
                      header3.innerText = template.format(months[firstMonth+2]);
                  }
              }
            }

            // summary table
            self.getSummaryTable(self.periodid);

            if (typeof(periodData) == 'undefined')
                periodData = data;
            self.repopulateImportTable(data);
        });
    }

    init() {
        // get type of page
        this.meta = $(".metatable");
        this.cid = this.meta.attr('data-company');
        var pagetype = this.meta.attr('data-pagetype');
        if (!pagetype) return;
        switch (pagetype) {
            case 'dashboard' :
                this.showOrHideLGGSummary();
                break;
            case 'handel':
                this.setupHandel(this);
                break;
            case 'verbrauch':
                Consume.init(this, '/api/v1', this.meta);
                break;
            case 'production':
                Production.init(this, '/api/v1', this.meta);
                break;
        }


        $(document).click(function () {
            if (!doNotPropogate) {
                $('#errcard').hide();
            }
            doNotPropogate = false;
        });
    }

    getCompanies(cb, cbdata) {
        var self = this;
        $.ajax({
            type: "GET",
            url: '/api/v1/companies/' + clr.cid + '/companies',
            dataType: 'json'
        }).done(function (data) {
            cb(null, data, cbdata);
        }).fail(function (payload) {
            var me = $('.#metatable');
            if (payload.responseJSON) {
                self.log(payload.responseJSON.message, me);
            } else {
                self.log(payload.responseText, me);
            }
        });
    }

    getCompaniesWithEmpty(cb, cbdata) {
        this.getCompanies(function(_err, data, cbdata2) {
          data.unshift({
            companyid: -1,
            companynr: -1,
            name: '---',
          });
          cb(_err, data, cbdata2);
        }, cbdata);
    }

    allGasTypes(cb) {
      var _this = this;
      if(_this.gastypeCache != null) {
        return cb(_this.gastypeCache);
      }

      $.ajax({
          type: "GET",
          url: '/api/v1/companies/' + clr.cid + '/gastypes',
          dataType: 'json'
      }).done(function (data) {
          _this.gastypeCache = [INVALID_GAS_TYPE].concat(data);
          cb(_this.gastypeCache);
      }).fail(function (payload) {
          var me = $('.#metatable');
          if (payload.responseJSON) {
              _this.log(payload.responseJSON.message, me);
          } else {
              _this.log(payload.responseText, me);
          }
      });
    }

    getTypes(cb, cbdata) {
        var _this = this;
        _this.allGasTypes(function(types) {
            for (let i = 0; i < types.length; i++) {
                _this.gastypesById[types[i].key] = types[i];
            }
            cb(null, types, cbdata);
        });
    }

    updateFile(cb,cbdata) {
 
    }

    getFile(cb, cbdata) {

      $.ajax({
          type: "GET",
          url: '/api/v1/companies/' + clr.cid + '/gastypes',
          dataType: 'json'
      }).done(function(data){
      }).fail(function(data){
      })
    

    }

    getImportTypes(cb, cbdata) {
        var _this = this;
        _this.allGasTypes(function(types) {
            var results = [];
            for (let i = 0; i < types.length; i++) {
                if(types[i].import === 'biogas') {
                    results.push(types[i]);
                }
            }
            cb(null, results, cbdata);
        });
    }

    getImportLGGTypes(cb, cbdata) {
        var _this = this;
        _this.allGasTypes(function(types) {
            var results = [];
            for (let i = 0; i < types.length; i++) {
                if(types[i].import === 'lgg') {
                    results.push(types[i]);
                }
            }
            cb(null, results, cbdata);
        });
    }

    getGasTypes(cb) {
        var self = this;
        if (this.gastypesById.length) {
            return cb(null, this.gastypesById);
        } else {
            this.getTypes(function (err, data) {
                cb(null, self.gastypesById);
            }, null);
        }
    }

    recomputeTotal(tbl) {
        var amount = {};
        for(let i = 0; i < GASTYPES.length; i++) {
          amount[GASTYPES[i]] = 0;
        }
        tbl.find('.datacontent > tr').each(function () {
            var r = $(this);
            var m = r.find('.amount').attr('data-value');
            var t = r.find('.gastype').attr('data-value');
            amount[t] += parseInt(m);
        });

        for(let i = 0; i < GASTYPES.length; i++) {
          let element = tbl.find('.totalline td.amount .' + GASTYPES[i]);
          element.text(this.amountString(amount[GASTYPES[i]]));
          element.attr('data-amount', amount[GASTYPES[i]]);
        }

        return amount;
    }

    recomputeTotal3(tbl) {
        var self = this;
        var amount = {'TOTAL': 0};
        var globalTotal = 0;
        for(let i = 0; i < GASTYPES.length; i++) {
          amount[GASTYPES[i]] = 0;
        }
        tbl.find('.datacontent > tr').each(function () {
            var r = $(this);
            var m = r.find('.totalamount');
            var totalcol = r.find('.totalcol');
            var erdgas = 0;
            var total = 0;
            if (m.length && (m !== "undefined")) {
                var tot = parseInt(m.attr('data-value'));
                amount.TOTAL += tot;
                erdgas = tot;
            }
            for(let i = 0; i < GASTYPES.length; i++) {
              var value = r.find('.' + GASTYPES[i]).attr('data-value');
              if(value) {
                var am = parseInt(value);
                amount[GASTYPES[i]] += am;
                erdgas -= am;
                total += am;
              }
            }
            globalTotal += total;
            if (m.length) {
                if (isNaN(erdgas)) {
                  erdgas = 0;
                }
                r.find('.erdgas').text(self.amountString(erdgas));
            }
            if (totalcol.length) {
                totalcol.text(self.amountString(total));
            }
        });
        tbl.find('.totalline td.sumall').text(self.amountString(amount.TOTAL));
        tbl.find('.totalline td.totalcol').text(self.amountString(globalTotal));
        let rest = amount.TOTAL;
        for(let i = 0; i < GASTYPES.length; i++) {
          let element = tbl.find('.totalline td.' + GASTYPES[i]);
          if (isNaN(amount[GASTYPES[i]])) {
              amount[GASTYPES[i]] = 0;
          }
          element.text(self.amountString(amount[GASTYPES[i]]));
          element.attr('data-amount', amount[GASTYPES[i]]);
          rest -= amount[GASTYPES[i]];
        }
        if (isNaN(rest)) {
          rest = 0;
        }
        tbl.find('.totalline td.erdgas').text(self.amountString(rest));
    }

    recomputeZaehler(tbl) {
        var self = this;
        var diffkg = 0.0;
        tbl.find('.datacontent > tr').each(function () {
            var r = $(this);
            var stand = r.find('.stand').attr('data-value');
            if (typeof stand == 'undefined') {
                return;
            }
            var factor = r.find('.factor').attr('data-value');
            var standalt = r.find('.standalt').attr('data-value');
            if (standalt == '') {
                standalt = 0;
            }

            var diff = parseInt(stand) - parseInt(standalt);
            r.find('.diff').text(numberWithCommas(diff));
            var diff = diff * parseFloat(factor);
            r.find(".diffkg").text(self.amountString(diff.toFixed(2)));
            diffkg += diff;
        });
        tbl.find('.totalline > .diffkg').text(self.amountString(diffkg.toFixed(2)));
    }

    updateCounter(model, mid, m, value, cb) {
        value = value.toPrecision(5);
        this.updateElement(model, mid, m, value, cb);
    }

    updateElement(model, mid, m, value, cb) {
        var data = {};
            var me = $('tr[data-id="' + mid + '"][data-label="' + model.rowLabel + '"] td.' + m.key);
        var self = this;
        data[m.key] = value;
        $.ajax({
            type: "PUT",
            url: model.patchurl + mid,
            data: data,
            dataType: 'json'
        }).done(function (data) {
            if (model.recompute) {
                model.recompute();
            }
            $('#errcard').hide();
            cb(null, data);
        }).fail(function (payload) {
            var me = $('tr[data-id="' + mid + '"][data-label="' + model.rowLabel + '"] td.' + m.key);
            if (payload.responseJSON) {
                clr.log(payload.responseJSON.message, me);
                cb(payload);
            } else {
                clr.log(payload.responseText, me);
                cb(payload);
            }
        });
    }

    getSummaryTable(periodid) {
        var self = this;
        // get inital summary table
        $.ajax({
            type: "GET",
            url: '/api/v1/companies/' + clr.cid + '/periods/' + periodid + '/verbrauch',
            dataType: 'json'
        }).done(function (data) {
            for (let i = 0; i < GASTYPES.length; i++) {
                for (let j = 0; j < GROUPS.length; j++) {
                    let element = $('#totalamount .' + GROUPS[j] + '-' + GASTYPES[i]);
                    if(element && element.length) {
                      element.attr('data-amount', data[GROUPS[j]][GASTYPES[i]]);
                      element.text(numberWithCommas(data[GROUPS[j]][GASTYPES[i]]));
                    }
                }
            }
            self.recomputeSummary();
        }).fail(function (payload) {
            var me = $('#totalamount');
            if (payload.status != 200) {
                if (payload.responseJSON) {
                    self.log(payload.responseJSON.message, me);
                } else {
                    self.log(payload.responseText, me);
                }
            }
        });
    }

    recomputeSummary() {
        for (let i = 0; i < GASTYPES.length; i++) {
            let tot = 0;
            for(let j = 0; j < PRODUCTION_GROUPS.length; j++) {
              let element = $('#totalamount .' + PRODUCTION_GROUPS[j] + '-' + GASTYPES[i]);
              if(element && element.length) {
                tot += parseInt(element.attr('data-amount'));
              }
            }
            for(let j = 0; j < USAGE_GROUPS.length; j++) {
              let element = $('#totalamount .' + USAGE_GROUPS[j] + '-' + GASTYPES[i]);
              if(element && element.length) {
                tot -= parseInt(element.attr('data-amount'));
              }
            }
            $('#totalamount .total-' + GASTYPES[i]).text(numberWithCommas(tot));
        }
        this.showOrHideLGGSummary();

    }
    
    repopulateImportTable(data){
        if (typeof(periodData) == 'undefined')
            periodData = data;

        var importTable = $('#importe')
        if (!!importTable && (importTable.length > 0)) {
            for (var i = 1, row; row = importTable[0].rows[i]; i++) {
              if (row.cells.length < 4) continue;
              var targetDiv = row.cells[3].querySelector('.certificate-div');
              if (!targetDiv) continue;
              var id = targetDiv.getAttribute('data-id');
              targetDiv.innerHTML = clr.populateCertificateDiv(id);
            }
        }
    }

    getPeriods(type, cb, setperiod) {
        moment.locale('de');
        var self = this;
        var url = '';
        if (type == 'handel') {
            url = '/api/v1/companies/' + clr.cid + '/periods';
        } else {
            url = '/api/v1/companies/' + clr.cid + '/production/periods';
        }
        $.ajax({
            type: "GET",
            url: url,
            dataType: 'json'
        }).done(function (data) {
            var elems = [];
            if (typeof setperiod === 'undefined' && data.length) {
                setperiod = data[0].periodid;
            }
            for (let i = 0; i < data.length; i++) {
                if (type == 'handel') {
                    self.periods[data[i].periodid] = data[i];
                } else {
                    self.prodperiods[data[i].periodid] = data[i];
                    if (data[i].periodid == setperiod) {
                        for(let j = 0; j < GASTYPES.length; j++) {
                          if (data[i].gastypes.indexOf(GASTYPES[j]) < 0) {
                            $('.totalline .' + GASTYPES[j]).hide();
                            $('.totalline .title-' + GASTYPES[j]).hide();
                          }
                        }
                    }
                }
                var startdate = new moment(data[i].startdate);
                var enddate = new moment(data[i].enddate);
                //var item = { periodid: data[i].periodid, value: startdate.format('L') + ' - ' + enddate.format('L') };
                var item = { periodid: data[i].periodid, value: enddate.format('MM.YYYY') };
                elems.push(item);
            }
            var frm = {
                items: [
                    {
                        type: 'select',
                        key: 'period',
                        elements: elems,
                        elemkey: 'periodid',
                        elemvalue: 'value',
                        value: self.periodid
                    }
                ]
            };
            var f = Form.new(frm);
            var h = f.out();
            $(".metatable .period").html(h);
            $(".metatable .period select").change(function (e) {
                var me = $(this);
                var first = me.find('option:first');
                if (first) {
                    var firstval = first.attr('value');
                }
                var myval = me.val();
                if (firstval != myval) {
                    $("#counternote").hide();
                } else {
                    $("#counternote").show();
                }
                cb(null, me, data);
            });

            if (elems[0]) {

                cb(null, setperiod, data);
            }
        }).fail(function (payload) {
            var me = $('.#metatable');
            if (payload.responseJSON) {
                self.log(payload.responseJSON.message, me);
            } else {
                self.log(payload.responseText, me);
            }
        });
    }

    handelperiods() {
        return this.periods;
    }

    productionperiods() {
        return this.prodperiods;
    }

    log(text, sibling) {
        var pos = sibling.offset();
        var rbox = $("#errcard");
        if (pos) {
          rbox.css('top', parseInt(pos.top) - 100 + 'px');
          rbox.css('left', parseInt(pos.left) + 10 + 'px');
        }
        rbox.text(text);
        rbox.show();
    }

    printnumber(key, data) {
        return numberWithCommas(data[key]);
    }

   
}

export function updateLGGField(model, mid, data, field) {
    var me = $('tr[data-id="' + mid + '"][data-label="' + model.rowLabel + '"] td.' + field )[0];
    me.dataset.value = data[field];
    me.innerHTML = numberWithCommas(data[field]) + " kg";
}

export function numberWithCommas(x) {
    if (x && typeof x.toString === 'function') {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    } else {
        return x;
    }
}

export function round(number, decimalPlaces) {
    if (typeof number == "string") {
        number = parseFloat(number);
    }
    const factorOfTen = Math.pow(10, decimalPlaces);
    return Math.round( number * factorOfTen) / factorOfTen;
}

String.prototype.format = function() {
    var formatted = this;
    for (var i = 0; i < arguments.length; i++) {
        var regexp = new RegExp('\\{'+i+'\\}', 'gi');
        formatted = formatted.replace(regexp, arguments[i]);
    }
    return formatted;
};
